// src/pages/LoginPage.js - Beautiful Authentication
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/Loader';
import { loginUser } from '../services/api';

const LoginPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: ''
  });
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleTabSwitch = (loginTab) => {
    setIsLogin(loginTab);
    setFormData({ name: '', email: '', password: '', phone: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (isLogin) {
      const result = await login(formData.email, formData.password);
      console.log('Login result:', result); // <-- Add this
      setLoading(false);
      if (result && result.success) {
        console.log('Redirecting to /profile...');
        navigate('/profile');
      } else {
        alert(result?.message || 'Authentication failed. Please try again.');
      }
    } else {
      // Registration
      const payload = {
        name: formData.name, // should be a plain string, e.g. "Kola lawrence"
        email: formData.email,
        password: formData.password,
        phone: formData.phone
      };
      const result = await register(payload);
      setLoading(false);
      if (result && result.success) {
        alert('Registration successful! Please log in.');
        setIsLogin(true); // Switch to login tab
        setFormData({ name: '', email: '', password: '', phone: '' });
      } else {
        alert(result?.message || 'Registration failed. Please try again.');
      }
    }
  };

  return loading ? <Loader text="Loading menu..." /> : (
    <div className="login-page">
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, var(--nigeria-green), var(--warm-orange))',
        color: 'white',
        padding: '2rem 0',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>
            👤 {isLogin ? 'Welcome Back!' : 'Join TiwaTinwa'}
          </h1>
          <p style={{ fontSize: '1.1rem' }}>
            {isLogin ? 'Login to order your favorite Nigerian dishes' : 'Create an account to start ordering'}
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div style={{
            maxWidth: '500px',
            margin: '0 auto',
            background: 'white',
            padding: '3rem',
            borderRadius: '20px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.1)'
          }}>
            
            {/* Toggle Buttons */}
            <div style={{
              display: 'flex',
              marginBottom: '2rem',
              background: '#f8f9fa',
              borderRadius: '10px',
              padding: '4px'
            }}>
              <button
                onClick={() => handleTabSwitch(true)}
                style={{
                  flex: 1,
                  padding: '12px',
                  border: 'none',
                  borderRadius: '8px',
                  background: isLogin ? 'var(--nigeria-green)' : 'transparent',
                  color: isLogin ? 'white' : 'var(--text-dark)',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                🔑 Login
              </button>
              <button
                onClick={() => handleTabSwitch(false)}
                style={{
                  flex: 1,
                  padding: '12px',
                  border: 'none',
                  borderRadius: '8px',
                  background: !isLogin ? 'var(--nigeria-green)' : 'transparent',
                  color: !isLogin ? 'white' : 'var(--text-dark)',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                📝 Register
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit}>
              {!isLogin && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '600',
                    color: 'var(--text-dark)'
                  }}>
                    👤 Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required={!isLogin}
                    style={{
                      width: '100%',
                      padding: '15px',
                      border: '2px solid #e9ecef',
                      borderRadius: '10px',
                      fontSize: '1rem',
                      outline: 'none',
                      transition: 'border-color 0.3s ease'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--nigeria-green)'}
                    onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    placeholder="Enter your full name"
                  />
                </div>
              )}

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '600',
                  color: 'var(--text-dark)'
                }}>
                  📧 Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '15px',
                    border: '2px solid #e9ecef',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    outline: 'none',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--nigeria-green)'}
                  onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                  placeholder="Enter your email"
                />
              </div>

              {!isLogin && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '600',
                    color: 'var(--text-dark)'
                  }}>
                    📱 Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required={!isLogin}
                    style={{
                      width: '100%',
                      padding: '15px',
                      border: '2px solid #e9ecef',
                      borderRadius: '10px',
                      fontSize: '1rem',
                      outline: 'none',
                      transition: 'border-color 0.3s ease'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--nigeria-green)'}
                    onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    placeholder="Enter your phone number"
                  />
                </div>
              )}

              <div style={{ marginBottom: '2rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '600',
                  color: 'var(--text-dark)'
                }}>
                  🔒 Password
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '15px',
                    border: '2px solid #e9ecef',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    outline: 'none',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--nigeria-green)'}
                  onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                  placeholder="Enter your password"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: loading ? '#ccc' : 'var(--gradient-nigeria)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  marginBottom: '1rem'
                }}
              >
                {loading ? '⏳ Processing...' : (isLogin ? '🚀 Login' : '📝 Create Account')}
              </button>

              <div style={{ textAlign: 'center' }}>
                <Link 
                  to="/" 
                  style={{ 
                    color: 'var(--nigeria-green)', 
                    textDecoration: 'none',
                    fontWeight: '500'
                  }}
                >
                  ← Back to Homepage
                </Link>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoginPage;